var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "record-comments" }, [
    _c(
      "div",
      { staticClass: "comment-list" },
      _vm._l(_vm.comments, function (comment) {
        return _c(
          "div",
          {
            key: comment._id,
            class: [
              "comment-item",
              {
                "private-comment":
                  _vm.$_.get(comment, "visibility.mode") === "private",
              },
            ],
          },
          [
            _c(
              "div",
              { staticClass: "comment-header" },
              [
                _c("Avatar", {
                  attrs: {
                    size: 35,
                    src: _vm.getUserAvatar(comment.user),
                    username: _vm.getUserName(comment.user),
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "comment-username" }, [
                  _vm._v(_vm._s(_vm.getUserName(comment.user))),
                ]),
                _vm._v(" "),
                _vm.$_.get(comment, "visibility.mode") === "private"
                  ? _c(
                      "span",
                      { staticClass: "private-badge" },
                      [
                        _c("a-icon", { attrs: { type: "lock" } }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("chatWindow.private")) +
                            "\n                "
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", { staticClass: "comment-date" }, [
                  _vm._v(_vm._s(_vm.formatDate(comment.createdAt))),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "comment-body" }, [
              _vm.editingCommentId === comment._id
                ? _c("div", [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editedCommentMessage,
                          expression: "editedCommentMessage",
                        },
                      ],
                      domProps: { value: _vm.editedCommentMessage },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.editedCommentMessage = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("button", { on: { click: _vm.cancelEdit } }, [
                      _vm._v(_vm._s(_vm.$t("tables.cancel"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.saveComment(comment._id)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("tables.save")))]
                    ),
                  ])
                : _c("div", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(comment.message) +
                        "\n                "
                    ),
                  ]),
            ]),
            _vm._v(" "),
            _vm.isCommentOwner(comment)
              ? _c("div", { staticClass: "comment-actions" }, [
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.editComment(comment)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.edit")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.deleteComment(comment._id)
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.delete")))]
                  ),
                ])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "new-comment" }, [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.newCommentMessage,
            expression: "newCommentMessage",
          },
        ],
        attrs: { placeholder: _vm.$t("task.addComment") },
        domProps: { value: _vm.newCommentMessage },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.newCommentMessage = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "comment-controls" },
        [
          _c(
            "a-radio-group",
            {
              staticClass: "visibility-toggle",
              model: {
                value: _vm.commentVisibilityMode,
                callback: function ($$v) {
                  _vm.commentVisibilityMode = $$v
                },
                expression: "commentVisibilityMode",
              },
            },
            [
              _c(
                "a-radio",
                { attrs: { value: "public" } },
                [
                  _c("a-icon", { attrs: { type: "global" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.public")) +
                      "\n                "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-radio",
                { attrs: { value: "private" } },
                [
                  _c("a-icon", { attrs: { type: "lock" } }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("chatWindow.private")) +
                      "\n                "
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("button", { on: { click: _vm.addComment } }, [
            _vm._v(_vm._s(_vm.$t("task.addComment"))),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }